<template>
  <el-dialog
    :visible="visible"
    width="30%"
    append-to-body
    @close="handleClose"
  >
    <el-form label-width="100px" :model="editTransaction" ref="editTransaction">
      <el-row>
        <el-form-item :label="title" prop="receivables">
          <el-input
            size="small"
            v-model="editTransaction.receivables"
            auto-complete="off"
            placeholder="应收款"
          ></el-input>
        </el-form-item>
      </el-row>
      
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateReceivables } from "@/api/ticket/ticket";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: Number ,
      default: 0,
    },
    id: {
      type: Number ,
      default: 0,
    },
    editTransaction: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      
    };
  },
  methods: {
    handleSubmit() {
      this.editTransaction.type = this.type;
      this.editTransaction.id = this.id;
      updateReceivables(this.editTransaction)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.warning);
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editTransaction.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-flow/add-edit/transaction.vue